import { SellRepository } from "../domain/repositories/SellRepository";
import { SellDataRepository } from '../data/SellDataRepository';
import { BalanceDataRepository } from '../data/BalanceDataRepository';
import { BalanceRepository } from '../domain/repositories/BalanceRepository';
import { UIDataRepository } from '../data/UIDataRepository';
import { UIRepository } from '../domain/repositories/UIRepository';
import { SessionDataRepository } from '../data/SessionDataRepository';
import { SessionRepository } from '../domain/repositories/SessionRepository';
import { SkuDataRepository } from "../data/SkuDataRepository";
import { SkuRepository } from "../domain/repositories/SkuRepository";
import { HistoricDataRepository } from '../data/HistoricDataRepository';
import { HistoricRepository } from '../domain/repositories/HistoricRepository';
import { SessionCache } from '../data/localcache/SessionCache';

const sellRepoInstance = new SellDataRepository();
export function sellRepo(): SellRepository { return sellRepoInstance; }

const balanceRepoInstance = new BalanceDataRepository();
export function balanceRepo(): BalanceRepository { return balanceRepoInstance; }

const uiRepoInstance = new UIDataRepository();
export function uiRepo(): UIRepository { return uiRepoInstance; }

const sessionRepoInstance = new SessionDataRepository();
export function sessionRepo(): SessionRepository { return sessionRepoInstance; }

const sessionLocalRepoInstance = new SessionCache();
export function sessionLocalRepo() { return sessionLocalRepoInstance; }

const skuRepoInstance = new SkuDataRepository();
export function skuRepo(): SkuRepository { return skuRepoInstance; }

const historicRepoInstance = new HistoricDataRepository();
export function historicRepo(): HistoricRepository { return historicRepoInstance; }